export default __webpack_public_path__ + "static/media/cloud.041dd8a4.svg";